import styled from 'styled-components'

const ContenedorVertical = styled.div`
    display: flex;
    flex-flow: column;
    padding-right: 3.5rem;
`;

const ItemLabel = styled.div`
    flex: auto;
    font-size: 12px;
    color: #888;
    text-transform: uppercase;
`;

export {
    ContenedorVertical,
    ItemLabel
}